// "use client"

// import React from "react"
// import { cn } from "../../lib/utils"

// const Popover = ({ children }) => {
//   return <>{children}</>
// }

// const PopoverTrigger = ({ asChild = false, children, ...props }) => {
//   const [open, setOpen] = React.useState(false)

//   return (
//     <button onClick={() => setOpen(!open)} type="button" {...props}>
//       {children}
//     </button>
//   )
// }

// const PopoverContent = ({ children, className, ...props }) => {
//   return (
//     <div
//       className={cn(
//         "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
//         className,
//       )}
//       {...props}
//     >
//       {children}
//     </div>
//   )
// }

// export { Popover, PopoverTrigger, PopoverContent }


"use client"

import React, { useState } from "react"
import { cn } from "../../lib/utils"

// Add export for PopoverContext at the top of the file
export const PopoverContext = React.createContext({
  open: false,
  setOpen: () => {},
})

const Popover = ({ children }) => {
  const [open, setOpen] = useState(false)

  return (
    <PopoverContext.Provider value={{ open, setOpen }}>
      <div className="relative inline-block w-full">{children}</div>
    </PopoverContext.Provider>
  )
}

const PopoverTrigger = ({ asChild = false, children, ...props }) => {
  const { open, setOpen } = React.useContext(PopoverContext)

  return React.cloneElement(children, {
    ...props,
    ...children.props,
    onClick: (e) => {
      setOpen(!open)
      if (children.props.onClick) {
        children.props.onClick(e)
      }
    },
  })
}

const PopoverContent = ({ children, className, ...props }) => {
  const { open } = React.useContext(PopoverContext)

  if (!open) return null

  return (
    <div
      className={cn(
        "absolute z-50 w-auto rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none animate-in fade-in-0 zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}

export { Popover, PopoverTrigger, PopoverContent }
